import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { checkTokenAndRedirect } from '../utils/tokenExpiration';

/**
 * Public routes where token expiration check should be skipped
 * These are routes that don't require authentication
 */
const PUBLIC_ROUTES = [
  '/',
  '/login',
  '/maintains/login',
  '/register',
  '/signage/register',
  '/realtor/register',
  '/installer/register',
  '/agent/register',
  '/testapi',
  '/signage/welcome',
  '/realtor/welcome',
  '/installer/welcome',
  '/agent/welcome',
  '/forgotpassword',
  '/signage/forgotpassword',
  '/realtor/forgotpassword',
  '/signageteammember/forgot-password',
  '/agent/forgot-password',
  '/teammember/forgot-password',
  '/signage/RestPassword',
  '/realtor/RestPassword',
  '/signageteammember/RestPassword',
  '/agent/RestPassword',
  '/teammember/RestPassword',
  '/ordersummary',
  '/agent/design-review-portal',
  '/installationsummary',
  // '/trackshipment/... — matched in isPublicRoute (pathname is never "/trackshipment/:trackingCode")
  '/salesorder/invoice',
 '/installationorder/invoice',
 '/removaljob/invoice',
];

/**
 * Checks if the current route is a public route (doesn't require auth)
 */
function isPublicRoute(pathname: string): boolean {
  // Exact match or starts with public route
  if (pathname.startsWith('/assets/email/')) return true;
  // Public tracking links (email); actual path is /trackshipment/<code>, not the route pattern string
  if (pathname === '/trackshipment' || pathname.startsWith('/trackshipment/')) return true;
  return PUBLIC_ROUTES.some(route => {
    if (pathname === route) return true;
    // For routes like /salesorder/invoice, also match /salesorder/invoice/anything
    if (route.includes('/invoice')) {
      return pathname.startsWith(route);
    }
    return false;
  });
}

/**
 * Component that checks token expiration on every route change
 * This ensures users are logged out when their token expires
 * 
 * SKIPS checking on public routes (login, register, etc.)
 */
const TokenExpirationChecker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip token check on public routes (login, register, etc.)
    if (isPublicRoute(location.pathname)) {
      return;
    }

    // Only check token expiration on protected routes
    checkTokenAndRedirect();
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
};

export default TokenExpirationChecker;

